import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import CartItemPromoCode from './CartItemPromoCode';

import styles from './styles/CartItemTitle.scss';

const ArtTitle = ({ pdpURL, creatorName, title, creationDate, onClick }) => {
    return (
        <div>
            <div>{creatorName}</div>
            <a
                href={pdpURL}
                onClick={onClick}
                className={`${styles.link} link-pdp`}
                data-galocation="item title"
            >
                <span className="italic">{title}</span>
                {creationDate ? `, ${creationDate}` : null}
            </a>
        </div>
    );
};

ArtTitle.propTypes = {
    title: PropTypes.string.isRequired,
    pdpURL: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    creationDate: PropTypes.string,
};

const Title = ({ pdpURL, title, onClick }) => {
    return (
        <a
            href={pdpURL}
            onClick={onClick}
            className={`${styles.link} link-pdp`}
            data-galocation="item title"
        >
            {title}
        </a>
    );
};

Title.propTypes = {
    title: PropTypes.string.isRequired,
    pdpURL: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

const CartItemTitle = ({ item, user, isUnavailable, onClick }) => {
    const { title, pdpURL, creationDate, isArt } = item;
    const titleProps = { onClick, title, pdpURL };
    const creatorName = get(item, 'creators[0].creator.name') || '';

    const titleMain = <Title {...titleProps} />;
    const titleArt = (
        <ArtTitle {...titleProps} creatorName={creatorName} creationDate={creationDate} />
    );
    const titleComponent = isArt ? titleArt : titleMain;

    return (
        <div className={styles.name} data-tn="cart-cart-item-name">
            {isUnavailable ? title : titleComponent}
            {user && <CartItemPromoCode user={user} item={item} />}
        </div>
    );
};

CartItemTitle.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    isUnavailable: PropTypes.bool,
    onClick: PropTypes.func,
};

export default createFragmentContainer(CartItemTitle, {
    item: graphql`
        fragment CartItemTitle_item on Item {
            ...CartItemPromoCode_item @include(if: $hasUserId)
            title
            isArt
            pdpURL
            createdDate
            creators {
                creator {
                    name
                }
            }
        }
    `,
    user: graphql`
        fragment CartItemTitle_user on User {
            ...CartItemPromoCode_user
        }
    `,
});
